var BUTTON_TYPE;
(function (BUTTON_TYPE) {
    BUTTON_TYPE["BUTTON"] = "button";
    BUTTON_TYPE["RESET"] = "reset";
    BUTTON_TYPE["SUBMIT"] = "submit";
})(BUTTON_TYPE || (BUTTON_TYPE = {}));
var BUTTON_VARIANT;
(function (BUTTON_VARIANT) {
    BUTTON_VARIANT["DEFAULT"] = "default";
    BUTTON_VARIANT["GHOST"] = "ghost";
    BUTTON_VARIANT["ICON"] = "icon";
    BUTTON_VARIANT["PROMINENT"] = "prominent";
    BUTTON_VARIANT["SUBTLE"] = "subtle";
    BUTTON_VARIANT["TEXT"] = "text";
})(BUTTON_VARIANT || (BUTTON_VARIANT = {}));
export { BUTTON_VARIANT, BUTTON_TYPE };
